(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    // ── Swatch click → swap card image (no navigation) ─────────────────────────
  (function () {
    var cache = {};

    function getProductHandle(item) {
      // Try <a href> inside the swatch item
      var a = item.querySelector('a[href]');
      if (a) {
        var m = a.href.match(/\/products\/([a-z0-9_-]+)/i);
        if (m) return m[1];
      }
      // Try data attributes
      var handle = item.dataset.handle || item.dataset.productHandle;
      if (handle) return handle;
      // Try the card's main link
      var card = item.closest('product-card, .product-card, [data-product-id]');
      if (card) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          var m2 = link.href.match(/\/products\/([a-z0-9_-]+)/i);
          if (m2) return m2[1];
        }
      }
      return null;
    }

    function getVariantId(item) {
      // LV often stores variant id in data-variant-id or href ?variant=
      if (item.dataset.variantId) return item.dataset.variantId;
      var a = item.querySelector('a[href]');
      if (a) {
        var m = a.href.match(/[?&]variant=(\d+)/);
        if (m) return m[1];
      }
      return null;
    }

    function findCardImg(item) {
      var card = item.closest('product-card, .product-card, li');
      if (!card) return null;
      return card.querySelector('.product-media img, .product-card__image img, img[srcset]');
    }

    function setActiveSwatches(clickedItem) {
      var group = clickedItem.closest('.lv-option-group');
      if (!group) return;
      group.querySelectorAll('.lv-option-item').forEach(function (i) {
        i.classList.remove('lv-option-item__active');
      });
      clickedItem.classList.add('lv-option-item__active');
    }

    function swapImage(img, newSrc) {
      // Build a srcset-friendly URL for Shopify CDN
      var base = newSrc.split('?')[0];
      img.src = base + '?width=800';
      if (img.srcset) {
        img.srcset = [400, 600, 800, 1000].map(function (w) {
          return base + '?width=' + w + ' ' + w + 'w';
        }).join(', ');
      }
    }

    document.addEventListener('click', function (e) {
      var item = e.target.closest('.lv-option-item');
      if (!item) return;
      // Only act on collection-page swatches (not PDP)
      if (!item.closest('.king-linked-options-collection__container')) return;
      // Skip already active
      if (item.classList.contains('lv-option-item__active')) return;

      var img = findCardImg(item);
      if (!img) return; // no image to swap → let normal navigation happen

      e.preventDefault();
      e.stopPropagation();

      var handle = getProductHandle(item);
      var variantId = getVariantId(item);

      if (!handle) { setActiveSwatches(item); return; }

      function applyVariant(product) {
        var variant = null;
        if (variantId) {
          variant = (product.variants || []).find(function (v) { return String(v.id) === String(variantId); });
        }
        // Fallback: first available variant
        if (!variant) variant = (product.variants || []).find(function (v) { return v.available; }) || (product.variants || [])[0];
        if (!variant) return;

        // Get featured image for this variant
        var imgSrc = null;
        if (variant.featured_image && variant.featured_image.src) {
          imgSrc = variant.featured_image.src;
        } else if (product.featured_image) {
          imgSrc = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
        }
        if (imgSrc) swapImage(img, imgSrc);
        setActiveSwatches(item);
      }

      if (cache[handle]) {
        applyVariant(cache[handle]);
      } else {
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (!p) return;
            cache[handle] = p;
            applyVariant(p);
          });
      }
    }, true); // capture phase so we intercept before LV's own handler
  })();

  // KLO structure: .lv-option-collection-items > .lv-option-collection-wrapper×N + .lv-option-collection-swatch-more
  // KLO may only render a subset of colors (e.g. 8 of 11) and show its own "+3".
  // We cap at MAX=3 visible and must add KLO's hidden count to our own.
  function runSwatchFit() {
    var MAX = 3;
    document.querySelectorAll('.king-linked-options-collection__container').forEach(function (container) {
      var itemsEl = container.querySelector('.lv-option-collection-items');
      if (!itemsEl) return;

      var wrappers = Array.from(itemsEl.querySelectorAll('.lv-option-collection-wrapper'));
      var moreEl  = itemsEl.querySelector('.lv-option-collection-swatch-more');

      // Read KLO's original "+N" once and store on container to survive MO re-runs
      if (!('kloExtra' in container.dataset)) {
        var kloN = 0;
        if (moreEl) {
          var m = moreEl.textContent.trim().match(/\+(\d+)/);
          if (m) kloN = parseInt(m[1], 10);
        }
        container.dataset.kloExtra = kloN;
      }
      var kloExtra = parseInt(container.dataset.kloExtra, 10) || 0;
      var total = wrappers.length + kloExtra;

      // Hide container if only 1 color total
      if (total <= 1) {
        container.style.setProperty('display', 'none', 'important');
        return;
      }

      // Sort: in-stock first, out-of-stock last
      var inStock    = wrappers.filter(function (w) { return !w.querySelector('[class*="unavailable"]'); });
      var outOfStock = wrappers.filter(function (w) { return  !!w.querySelector('[class*="unavailable"]'); });
      var sorted = inStock.concat(outOfStock);

      // Show first MAX from sorted order, hide the rest.
      // Use CSS `order` to control visual position without touching DOM (no MO loop).
      var hiddenInDom = 0;
      sorted.forEach(function (w, i) {
        w.style.setProperty('order', i);
        if (i < MAX) {
          w.style.removeProperty('display');
        } else {
          w.style.setProperty('display', 'none', 'important');
          hiddenInDom++;
        }
      });

      var hidden = hiddenInDom + kloExtra;

      // Create +N element if KLO didn't inject one (some collections skip it)
      if (!moreEl && hidden > 0) {
        moreEl = document.createElement('div');
        moreEl.className = 'lv-option-collection-swatch-more';
        itemsEl.appendChild(moreEl);
      }

      // Update +N counter — always last visually
      if (moreEl) {
        moreEl.style.setProperty('order', 9999);
        if (hidden > 0) {
          // Only write when the text actually changes: textContent always replaces the
          // text node (a childList mutation), which re-triggers the MutationObserver
          // below and looped runSwatchFit forever (~170 DOM writes/s on live 2026-09-29).
          var moreText = '+' + hidden;
          if (moreEl.textContent !== moreText) moreEl.textContent = moreText;
          moreEl.style.removeProperty('display');
        } else {
          moreEl.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  // Multiple retries — King LinkedOptions may inject swatches late
  window.addEventListener('load', function () {
    setTimeout(runSwatchFit, 100);
    setTimeout(runSwatchFit, 600);
    setTimeout(runSwatchFit, 1500);
    setTimeout(runSwatchFit, 3000);
  });

  // MutationObserver — catches infinite scroll, AJAX-loaded sections, carousels
  (function () {
    if (!window.MutationObserver) return;
    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; runSwatchFit(); }, 80);
    });
    function startObs() { obs.observe(document.body || document.documentElement, { childList: true, subtree: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObs);
    else startObs();
  })();
  } catch(e) { console.error(e); }
})();

})();
